import * as Yup from 'yup';

const CostTierSchema = Yup.object().shape({
  case_cost: Yup.number().required(),
  min_cases: Yup.number().required(),
});

// year_month is a packed YYYYMM integer (e.g. 202604), not a string —
// dateutils.YearMonth.MarshalJSON. Confirmed in the Task 5 handler test.
const WindowLowSchema = Yup.object().shape({
  cost: Yup.number().required(),
  year_month: Yup.number().defined(),
});

const CostHistoryEntrySchema = Yup.object().shape({
  year_month: Yup.number().required(),
  frontline_cost: Yup.number().required(),
  lowest_achievable: Yup.number().required(),
  tiers: Yup.array().of(CostTierSchema).required(),
});

const WindowBoolsSchema = Yup.object().shape({
  '6': Yup.boolean().required(),
  '12': Yup.boolean().required(),
  '24': Yup.boolean().required(),
});

const WindowLowsSchema = Yup.object().shape({
  '6': WindowLowSchema.required(),
  '12': WindowLowSchema.required(),
  '24': WindowLowSchema.required(),
});

// recurrence / cycle_period_months / next_month_lowest_achievable are intentionally
// omitted — unused by the UI. Yup strips unknown keys by default, so this is safe
// even when the backend serializes next_month_lowest_achievable as literal null.
const CostSummarySchema = Yup.object().shape({
  current_month_lowest_achievable: Yup.number().required(),
  is_lowest_in_window: WindowBoolsSchema.required(),
  lowest_in_window: WindowLowsSchema.required(),
  months_since_last_low: Yup.number().nullable(),
});

export const CostHistoryResponseSchema = Yup.object().shape({
  vendor: Yup.string().defined(),
  series: Yup.array().of(CostHistoryEntrySchema).required(),
  summary: CostSummarySchema.optional().default(undefined),
});

export type CostHistoryResponse = Yup.InferType<typeof CostHistoryResponseSchema>;
export type CostHistoryEntry = Yup.InferType<typeof CostHistoryEntrySchema>;
